import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const Workflow = props => {
  const $ = _c(17);
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M4.375 5.20831C5.06536 5.20831 5.625 4.64867 5.625 3.95831C5.625 3.26796 5.06536 2.70831 4.375 2.70831C3.68464 2.70831 3.125 3.26796 3.125 3.95831C3.125 4.64867 3.68464 5.20831 4.375 5.20831Z" stroke="currentColor" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M15.625 17.2917C16.3154 17.2917 16.875 16.732 16.875 16.0417C16.875 15.3513 16.3154 14.7917 15.625 14.7917C14.9346 14.7917 14.375 15.3513 14.375 16.0417C14.375 16.732 14.9346 17.2917 15.625 17.2917Z" stroke="currentColor" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M5.625 3.95831H15.625C16.3154 3.95831 16.875 4.5179 16.875 5.20831V8.54165C16.875 9.23206 16.3154 9.79165 15.625 9.79165H9.79167" stroke="currentColor" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M11.25 7.91669L9.375 9.79169L11.25 11.6667" stroke="currentColor" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M11.4585 16.6667C11.8037 16.6667 12.0835 16.3869 12.0835 16.0417C12.0835 15.6965 11.8037 15.4167 11.4585 15.4167C11.1133 15.4167 10.8335 15.6965 10.8335 16.0417C10.8335 16.3869 11.1133 16.6667 11.4585 16.6667Z" fill="currentColor" />;
    t5 = <path d="M9.375 16.6667C9.72018 16.6667 10 16.3869 10 16.0417C10 15.6965 9.72018 15.4167 9.375 15.4167C9.02982 15.4167 8.75 15.6965 8.75 16.0417C8.75 16.3869 9.02982 16.6667 9.375 16.6667Z" fill="currentColor" />;
    t6 = <path d="M7.2915 16.6667C7.63668 16.6667 7.9165 16.3869 7.9165 16.0417C7.9165 15.6965 7.63668 15.4167 7.2915 15.4167C6.94633 15.4167 6.6665 15.6965 6.6665 16.0417C6.6665 16.3869 6.94633 16.6667 7.2915 16.6667Z" fill="currentColor" />;
    t7 = <path d="M5.20825 16.6667C5.55343 16.6667 5.83325 16.3869 5.83325 16.0417C5.83325 15.6965 5.55343 15.4167 5.20825 15.4167C4.86307 15.4167 4.58325 15.6965 4.58325 16.0417C4.58325 16.3869 4.86307 16.6667 5.20825 16.6667Z" fill="currentColor" />;
    t8 = <path d="M3.125 16.6667C3.47018 16.6667 3.75 16.3869 3.75 16.0417C3.75 15.6965 3.47018 15.4167 3.125 15.4167C2.77982 15.4167 2.5 15.6965 2.5 16.0417C2.5 16.3869 2.77982 16.6667 3.125 16.6667Z" fill="currentColor" />;
    t9 = <path d="M3.125 14.5833C3.47018 14.5833 3.75 14.3035 3.75 13.9583C3.75 13.6131 3.47018 13.3333 3.125 13.3333C2.77982 13.3333 2.5 13.6131 2.5 13.9583C2.5 14.3035 2.77982 14.5833 3.125 14.5833Z" fill="currentColor" />;
    t10 = <path d="M3.125 12.5C3.47018 12.5 3.75 12.2202 3.75 11.875C3.75 11.5298 3.47018 11.25 3.125 11.25C2.77982 11.25 2.5 11.5298 2.5 11.875C2.5 12.2202 2.77982 12.5 3.125 12.5Z" fill="currentColor" />;
    t11 = <path d="M3.125 10.4167C3.47018 10.4167 3.75 10.1369 3.75 9.79169C3.75 9.44651 3.47018 9.16669 3.125 9.16669C2.77982 9.16669 2.5 9.44651 2.5 9.79169C2.5 10.1369 2.77982 10.4167 3.125 10.4167Z" fill="currentColor" />;
    t12 = <path d="M5.20825 10.4167C5.55343 10.4167 5.83325 10.1369 5.83325 9.79169C5.83325 9.44651 5.55343 9.16669 5.20825 9.16669C4.86307 9.16669 4.58325 9.44651 4.58325 9.79169C4.58325 10.1369 4.86307 10.4167 5.20825 10.4167Z" fill="currentColor" />;
    t13 = <path d="M7.2915 10.4167C7.63668 10.4167 7.9165 10.1369 7.9165 9.79169C7.9165 9.44651 7.63668 9.16669 7.2915 9.16669C6.94633 9.16669 6.6665 9.44651 6.6665 9.79169C6.6665 10.1369 6.94633 10.4167 7.2915 10.4167Z" fill="currentColor" />;
    t14 = <path d="M13.5415 16.0417H14.3748" stroke="currentColor" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t13 = $[5];
    t14 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t15;
  if ($[15] !== props) {
    t15 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}</svg>;
    $[15] = props;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  return t15;
};